import { ClassificationItem } from '../../types/fundScreener.type';

// Placeholder shown before useFundClassifications fetches the real list.
export const DEFAULT_CLASSIFICATIONS: ClassificationItem[] = [
  { value: 'ALL', label: 'All', activated: true },
];